import React from "react";
import Hero from "../components/Hero";
import About from "../components/About";
import RitualSection from "../components/RitualSection";
import MenuHighlights from "../components/MenuHighlights";
import Gallery from "../components/Gallery";
import ContactSection from "../components/ContactSection";

const HomePage = () => {
  return (
    <main data-testid="home-page">
      <Hero />
      <About />
      <RitualSection />
      <MenuHighlights />
      <Gallery compact />
      <ContactSection embedded />
    </main>
  );
};

export default HomePage;
